import { useRouter } from "next/router";
import React from "react";

import { FormattedText, ImageComponent } from "@tm/static";
import backArrow from "../../../../icons/backArrow.svg";
import {
  BackArrowButton,
  HeroTitlePWA,
  HeroTitleSectionPWA,
  HeroTopSection,
} from "../../OrderDetailV2.style";
import type { OrderDetailV2HeroPWAProps } from "../../types";

export const OrderDetailV2HeroPWA: React.FC<OrderDetailV2HeroPWAProps> = ({
  title,
}) => {
  const router = useRouter();

  const handleBackClick = () => {
    if (window.mmt_android_bridge) {
      window.mmt_android_bridge.closeWebView();
    } else {
      router.back();
    }
  };

  return (
    <>
      <HeroTopSection>
        <BackArrowButton type="button" onClick={handleBackClick}>
          <ImageComponent src={backArrow.src} width="24px" height="24px" />
        </BackArrowButton>
      </HeroTopSection>
      {title && (
        <HeroTitleSectionPWA>
          <HeroTitlePWA>
            <FormattedText value={title} />
          </HeroTitlePWA>
        </HeroTitleSectionPWA>
      )}
    </>
  );
};
